/**
 * First login (new accounts only, `Me.playedBefore === null`): 'Have you played Ka'Dice before?',
 * over everything else. The answer is saved to the account (`PUT /api/me/played-before`), so it is
 * asked once. No opens Learn to Play straight away (see `Main`); Yes goes on to the lobby.
 */
import { t } from '@kadice/shared';

export function Welcome({ onAnswer }: { onAnswer: (playedBefore: boolean) => void }) {
  return (
    <div className="learn learn-welcome">
      <div className="modal splash welcome-box" role="dialog" aria-modal="true" aria-labelledby="welcome-q">
        <img src="/img/logo.png" alt={t('app.title')} className="logo" />
        <h2 id="welcome-q">{t('welcome.question')}</h2>
        <div className="row actions welcome-actions">
          <button className="primary" onClick={() => onAnswer(true)}>
            {t('welcome.yes')}
          </button>
          <button className="primary" onClick={() => onAnswer(false)}>
            {t('welcome.no')}
          </button>
        </div>
      </div>
    </div>
  );
}
